
import EoContainer from '../EoContainer/EoContainer.vue'
import EoColumns from '../EoColumns/EoColumns.vue'
import EoColumn from '../EoColumns/EoColumn.vue'
import EoLogo from '../EoLogo/EoLogo.vue'
import EoIcon from '../EoIcon/EoIcon.vue'

export default {
  name: 'EoFooter',
  components: { EoContainer, EoColumns, EoColumn, EoLogo, EoIcon },
  props: {
    /**
     * Overwrite default lists of hyperlinks in the footer
     */
    shortcuts: {
      type: Object,
      default: () => {
        return {
          'Ga naar...': {
            'Onze thema\'s': '/',
            'Programma\'s': '/',
            'Podcasts': '/pers',
            'Evenementen': '/',
            'Magazines': '/',
            'Over ons': '/',
          },
        }
      },
    },
    /**
     * Overwrite default list of socials in the footer
     */
    socials: {
      type: Object,
      default: () => {
        return {
          'Volg ons op...': {
            instagram: {
              name: 'Instagram',
              path: 'https://www.instagram.com/omroepeo/',
            },
            facebook: {
              name: 'Facebook',
              path: 'https://www.facebook.com/evangelischeomroep/',
            },
            twitter: {
              name: 'Twitter',
              path: 'https://twitter.com/EOnl',
            },
            youtube: {
              name: 'Youtube',
              path: 'https://www.youtube.com/user/evangelischeomroep',
            },
            linkedin: {
              name: 'Linkedin',
              path: 'https://nl.linkedin.com/company/evangelische-omroep',
            },
            spotify: {
              name: 'Spotify',
              path: 'https://open.spotify.com/user/evangelischeomroep',
            },

          },
        }
      },
    },
    /**
     * Fix the position of the footer to bottom of the screen
     */
    fixed: {
      type: Boolean,
      default: false,
    },
    /**
     * Style: background color of the top of the footer
     */
    color: {
      type: String,
      default: 'primary',
    },
    /**
     * Style: text color of the top of the footer
     */
    textColor: {
      type: String,
      default: 'white',
    },
  },
  computed: {
    classes () {
      return {
        'eo-footer': true,
        'fixed': this.fixed,
      }
    },
    classesTop () {
      return {
        'eo-footer__top': true,
        ['color--' + this.color]: this.color,
      }
    },
    hasDefaultSlot () {
      return !!this.$slots.default
    },
    showFooterTop () {
      return this.hasDefaultSlot || (this.shortcuts && Object.entries(this.shortcuts).length > 0)
    },
  },
  created () {
    this.$parent.hasFooter = true
    this.$parent.spaceForFooter = 50 // border radius of footer
  },
  methods: {
    getHyperlinkTag (url) {
      if (url && typeof url === 'string') {
        if (
          url.startsWith('https://') ||
          url.startsWith('http://') ||
          url.startsWith('tel:') ||
          url.startsWith('mailto:') ||
          url.startsWith('whatsapp:') ||
          url.startsWith('#')
        ) {
          return 'a'
        }
        if (this.$root.$options.components.NuxtLink) {
          return 'nuxt-link'
        } else if (this.$root.$options.components.RouterLink) {
          return 'router-link'
        } else {
          return 'a'
        }
      }
    },
  },
}
